const cartLoadingBar = {
  expressDelivery: 'Express-Botendienst',
  regularDelivery: 'Botendienst mit Termin',
  expressDelivery2: 'Express Botendienst',
  regularDelivery2: 'Botendienst',
  free: 'Kostenlos',
  regularDeliveryFor: 'Botendienst für {deliveryPrice}',
  expressDeliveryFor: 'Express-Botendienst für {deliveryPrice}',
  moreToThreshold: 'noch {amount}',
  deliveryByAgreement: 'Botendienst nach Vereinbarung',
}

export default cartLoadingBar
